import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c4619fc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "log-page common-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "登录日志", -1));
const _hoisted_3 = {
  class: "serch-form"
};
const _hoisted_4 = {
  class: "log-table"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import useRoleStore from '@/store/modules/role';
import protoPagination from '@/components/proto-pagination.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'log',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const form = ref({
      admin_id: ''
    });
    let page = ref({
      page: 1,
      pageSize: 15
    });
    const roleStore = useRoleStore();
    const {
      logList,
      logTotal
    } = storeToRefs(roleStore);
    initData();
    function initData() {
      roleStore.logList = [];
      roleStore.logTotal = 0;
      roleStore.getLogListAction(page.value);
    }
    function handleLogList(type = '') {
      if (type === 'rest') {
        form.value.admin_id = '';
      }
      page.value.page = 1;
      let query = {
        ...form.value,
        ...page.value
      };
      roleStore.getLogListAction(query);
    }
    function handleLogTableCurrentChange(val) {
      page.value.page = val;
      let query = {
        ...form.value,
        ...page.value
      };
      roleStore.getLogListAction(query);
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        model: form.value,
        inline: true,
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "管理员ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.admin_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.admin_id = $event),
            style: {
              "width": "200px"
            },
            placeholder: "请输入管理员ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => handleLogList('rest'))
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleLogList
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [_unref(logList).length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _unref(logList),
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (_unref(page).page - 1) * _unref(page).pageSize), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "username",
          label: "名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "admin_id",
          label: "管理员ID"
        }), _createVNode(_component_el_table_column, {
          prop: "ip",
          label: "登录IP"
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "登录时间"
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(protoPagination, {
        page: _unref(page),
        total: _unref(logTotal),
        onCurrentChange: handleLogTableCurrentChange
      }, null, 8, ["page", "total"])])]);
    };
  }
});